import { addDefaultHeader, removeDefaultHeader, getDefaultHeader } from './http';

export function handleTokenChange(token) {
    if (token) {
        localStorage && localStorage.setItem('token', token);
        addDefaultHeader('X-Authorization', token);
    } else {
        localStorage && localStorage.removeItem('token');
        removeDefaultHeader('X-Authorization');
    }
}

export function getAuthToken() {
    try {
        return localStorage.getItem('token');
    } catch (e) {
        return null;
    }
}

export function getToken() {
    return getDefaultHeader('X-Authorization');
}

export function handleLinkTokenChange(token) {
    if (token) {
        addDefaultHeader('X-Authorization', token);
    } else {
        removeDefaultHeader('X-Authorization');
    }
}

export function getAuthSSO() {
    try {
        return localStorage.getItem('sso');
    } catch (e) {
        return null;
    }
}

export function setAuthSSO(isSSO) {
    if (isSSO) {
        localStorage.setItem('sso', isSSO);
    } else {
        localStorage.removeItem('sso');
    }
}
